import React from 'react';

function NoteFeature({ isMobile, t }) {
  return (
    <section
      style={{
        marginTop: 200,
        marginBottom: 40,
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <div
        style={{
          maxWidth: '1200px',
          width: '100%',
          padding: isMobile ? '0 20px' : '0 40px',
          color: '#f9fafb'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 16,
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              justifyContent: 'start',
              borderRadius: 18,
              padding: 18,
              backdropFilter: 'blur(10px)',
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: isMobile ? 24 : 30,
              alignItems: isMobile ? 'stretch' : 'center'
            }}
          >
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12, minWidth: 300 }}>
              {/* Carte 1 - Liste de courses */}
              <div style={{
                backgroundColor: 'rgba(30, 41, 59, 0.9)',
                borderRadius: 15,
                padding: '16px',
                border: '1px solid rgba(148, 163, 184, 0.2)',
                textAlign: 'left'
              }}>
                <h4 style={{ 
                  margin: '0 0 12px 0', 
                  fontSize: '0.8rem', 
                  fontWeight: 'bold', 
                  color: '#ffffff', 
                  fontFamily: 'Poppins-Medium',
                  textAlign: 'left'
                }}>
                  {t.shoppinglist}
                </h4>
                <ul style={{ margin: 0, padding: 0, listStyle: 'none', textAlign: 'left' }}>
                  <li style={{ marginBottom: '8px', fontSize: '0.6rem', color: '#ffffff', fontFamily: 'Poppins-Medium', textAlign: 'left' }}>- {t.chips}</li>
                  <li style={{ marginBottom: '8px', fontSize: '0.6rem', color: '#ffffff', fontFamily: 'Poppins-Medium', textAlign: 'left' }}>- {t.pasta}</li>
                  <li style={{ marginBottom: '8px', fontSize: '0.6rem', color: '#ffffff', fontFamily: 'Poppins-Medium', textAlign: 'left' }}>- {t.steak}</li>
                  <li style={{ marginBottom: '0', fontSize: '0.6rem', color: '#ffffff', fontFamily: 'Poppins-Medium', textAlign: 'left' }}>- {t.beers}</li>
                </ul>
              </div>

              {/* Carte 2 - Idées restos */}
              <div style={{
                backgroundColor: 'rgba(59, 130, 246, 0.9)',
                borderRadius: 15,
                padding: '16px',
                border: '1px solid rgba(148, 163, 184, 0.2)',
                textAlign: 'left'
              }}>
                <h4 style={{ 
                  margin: '0 0 12px 0', 
                  fontSize: '0.8rem', 
                  fontWeight: 'bold', 
                  color: '#ffffff', 
                  fontFamily: 'Poppins-Medium',
                  textAlign: 'left'
                }}>
                  {t.restaurantIdeas}
                </h4>
                <ul style={{ margin: 0, padding: 0, listStyle: 'none', textAlign: 'left' }}>
                  <li style={{ marginBottom: '8px', fontSize: '0.6rem', color: '#ffffff', fontFamily: 'Poppins-Medium', textAlign: 'left' }}>{t.restau1}</li>
                  <li style={{ marginBottom: '8px', fontSize: '0.6rem', color: '#ffffff', fontFamily: 'Poppins-Medium', textAlign: 'left' }}>{t.restau2}</li>
                  <li style={{ marginBottom: '0', fontSize: '0.6rem', color: '#ffffff', fontFamily: 'Poppins-Medium', textAlign: 'left' }}>{t.restau3}</li>
                </ul>
              </div>

              {/* Carte 3 - Rappel */}
              <div style={{
                backgroundColor: 'rgba(34, 197, 94, 0.9)',
                borderRadius: 15,
                padding: '16px',
                border: '1px solid rgba(148, 163, 184, 0.2)',
                textAlign: 'left'
              }}>
                <h4 style={{ 
                  margin: '0 0 12px 0', 
                  fontSize: '0.8rem', 
                  fontWeight: 'bold', 
                  color: '#ffffff', 
                  fontFamily: 'Poppins-Medium',
                  textAlign: 'left'
                }}>
                  {t.reminder}
                </h4>
                <ul style={{ margin: 0, padding: 0, listStyle: 'none', textAlign: 'left' }}>
                  <li style={{ marginBottom: '8px', fontSize: '0.6rem', color: '#ffffff', fontFamily: 'Poppins-Medium', textAlign: 'left' }}>- {t.sunscreen}</li>
                  <li style={{ marginBottom: '8px', fontSize: '0.6rem', color: '#ffffff', fontFamily: 'Poppins-Medium', textAlign: 'left' }}>- {t.bugspray}</li>
                  <li style={{ marginBottom: '0', fontSize: '0.6rem', color: '#ffffff', fontFamily: 'Poppins-Medium', textAlign: 'left' }}>- {t.playingcards}</li>
                </ul>
              </div>

              {/* Carte 4 - Excursions */}
              <div style={{
                backgroundColor: 'rgba(249, 115, 22, 0.9)',
                borderRadius: 15,
                padding: '16px',
                border: '1px solid rgba(148, 163, 184, 0.2)',
                textAlign: 'left'
              }}>
                <h4 style={{ 
                  margin: '0 0 12px 0', 
                  fontSize: '0.8rem', 
                  fontWeight: 'bold', 
                  color: '#ffffff', 
                  fontFamily: 'Poppins-Medium',
                  textAlign: 'left'
                }}>
                  {t.excursions}
                </h4>
                <ul style={{ margin: 0, padding: 0, listStyle: 'none', textAlign: 'left' }}>
                  <li style={{ marginBottom: '8px', fontSize: '0.6rem', color: '#ffffff', fontFamily: 'Poppins-Medium', textAlign: 'left' }}>- {t.boatday}</li>
                  <li style={{ marginBottom: '8px', fontSize: '0.6rem', color: '#ffffff', fontFamily: 'Poppins-Medium', textAlign: 'left' }}>- {t.castlevisit}</li>
                  <li style={{ marginBottom: '0', fontSize: '0.6rem', color: '#ffffff', fontFamily: 'Poppins-Medium', textAlign: 'left' }}>- {t.hiking}</li>
                </ul>
              </div>
            </div>
            <div style={{ flex: 1, alignItems: 'flex-center', justifyContent: 'flex-center', maxWidth: 400 }}>
              <h3
                style={{
                  margin: '0 0 8px 0',
                  fontSize: '2rem',
                  fontFamily: 'Poppins-Medium'
                }}
              >
                {t.NoteTitle}
              </h3>
              <p
                style={{
                  margin: 0,
                  fontSize: '1.1rem',
                  opacity: 0.9,
                  lineHeight: 1.6
                }}
              >
                {t.NoteText}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default NoteFeature;
